"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var ReactDOM = require("react-dom");
var index_1 = require("../src/ontodia/index");
var common_1 = require("./common");
function onWorkspaceMounted(workspace) {
    if (!workspace) {
        return;
    }
    var diagram = common_1.tryLoadLayoutFromLocalStorage();
    workspace.getModel().importLayout({
        diagram: tslib_1.__assign(tslib_1.__assign({}, diagram), { linkTypeOptions: [
                {
                    '@type': 'LinkTypeOptions',
                    property: 'http://www.researchspace.org/ontology/group',
                    visible: false,
                },
            ] }),
        validateLinks: true,
        dataProvider: new index_1.SparqlDataProvider({
            endpointUrl: '/sparql',
            imagePropertyUris: [
                'http://collection.britishmuseum.org/id/ontology/PX_has_main_representation',
                'http://xmlns.com/foaf/0.1/img',
            ],
            queryMethod: index_1.SparqlQueryMethod.GET,
            acceptBlankNodes: true,
        }, index_1.OWLStatsSettings),
    });
}
var props = {
    ref: onWorkspaceMounted,
    onSaveDiagram: function (workspace) {
        var diagram = workspace.getModel().exportLayout();
        window.location.hash = common_1.saveLayoutToLocalStorage(diagram);
        window.location.reload();
    },
    viewOptions: {
        onIriClick: function (_a) {
            var iri = _a.iri;
            return window.open(iri);
        },
        groupBy: [
            { linkType: 'http://www.researchspace.org/ontology/group', linkDirection: 'in' },
        ],
    },
    languages: [
        { code: 'en', label: 'English' },
        { code: 'de', label: 'German' },
        { code: 'ru', label: 'Russian' },
    ],
    language: 'ru',
    elementTemplateResolver: function (types) {
        if (types.indexOf('http://www.ics.forth.gr/isl/CRMinf/I2_Belief') !== -1) {
            return index_1.GroupTemplate;
        }
        return undefined;
    },
};
common_1.onPageLoad(function (container) { return ReactDOM.render(react_1.createElement(index_1.Workspace, props), container); });
